import { Check, Trash2 } from 'lucide-react';
import { timeAgo } from '../../shared/models';
import { notificationMeta } from './notificationMeta';

// Mirrors iOS DriverNotificationRowView plus the swipe actions (delete / mark
// read) rendered as inline icon buttons for the web.
export default function NotificationRow({ notification, onTap, onDelete, onMarkRead }) {
  const { Icon, cls } = notificationMeta(notification.type);
  // Admin broadcasts (promotion / data.broadcast) show the CheF logo.
  const isBroadcast = notification.type === 'promotion' || notification.data?.broadcast === 'true';
  return (
    <div
      onClick={onTap}
      className="w-full flex items-center gap-3 p-3 bg-white rounded-2xl shadow-sm border border-gray-100 text-left cursor-pointer active:bg-gray-50"
    >
      {isBroadcast ? (
        <img src="/ChefLogo.jpg" alt="CheF SKN" className="w-10 h-10 rounded-full object-cover shrink-0 bg-white" />
      ) : (
        <span className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${cls}`}>
          <Icon size={18} />
        </span>
      )}

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-[15px] font-semibold text-gray-900 truncate">
            {notification.title || 'Notification'}
          </span>
          <span className="ml-auto text-[11px] text-gray-400 shrink-0">
            {timeAgo(notification.createdAt)}
          </span>
        </div>
        <p className="text-sm text-gray-500 line-clamp-3">{notification.message}</p>
      </div>

      <div className="flex flex-col items-center gap-1.5 shrink-0">
        {!notification.isRead && <span className="w-2 h-2 rounded-full bg-blue-500" />}
        {!notification.isRead && (
          <button
            onClick={e => { e.stopPropagation(); onMarkRead(notification); }}
            className="p-1.5 rounded-full text-blue-500 hover:bg-blue-50"
            aria-label="Mark as read"
          >
            <Check size={15} />
          </button>
        )}
        <button
          onClick={e => { e.stopPropagation(); onDelete(notification); }}
          className="p-1.5 rounded-full text-red-400 hover:bg-red-50"
          aria-label="Delete notification"
        >
          <Trash2 size={15} />
        </button>
      </div>
    </div>
  );
}
